import React, { lazy, Suspense } from "react";
import { matchPath, Route, Routes, useLocation } from "react-router-dom";
import { PageCodes } from "../Pages/InfoDocPages/PageCodes";
import { PageCodesHero } from "../Pages/ProductSupportContact/PageRedirectCode";
import "../Acubot/acubot.js";
import Acubot from "../Acubot/Acubot.jsx";

/* Lazy importing components ...*/
const QuickQuotePage = lazy(
  () => import("../LifeInsurance/QuickQuote/QuickQuotePage"),
);

const HealthRoutes = lazy(() => import("./HealthRoutes"));
const MotorRoutes = lazy(() => import("./MotorRoutes/MotorRoutes"));
const SignIn = lazy(() => import("../components/userAuth/SignIn"));
const BApp = lazy(() => import("../BApp"));
const AboutUs = lazy(() => import("../Pages/AboutUs"));
const OurTeam = lazy(() => import("../Pages/OurTeam"));
const Career = lazy(() => import("../Pages/Career"));
const ContactUs = lazy(() => import("../Pages/ContactUs"));
const ServicePage = lazy(
  () => import("../Pages/ProductSupportContactNew/ProductSupportContactNew"),
);
const ProductSuppportContact = lazy(
  () => import("../Pages/ProductSupportContact/ProductSuppportContact"),
);

const TravelQQPage = lazy(
  () => import("../TravelInsurance/QuickQuote/QuickQuotePage"),
);

const InfoDocPages = lazy(() => import("../Pages/InfoDocPages/InfoDocPages"));

const CustomerRoutes = () => {
  const location = useLocation();

  // Pages where Acubot should be visible
  const allowedPages = [
    // Motor
    "/customer/motor-insurance/4wheeler/",
    "/customer/motor-insurance/4wheeler/products-list",
    "/customer/motor-insurance/2wheeler/",
    "/customer/motor-insurance/2wheeler/products-list",
    "/customer/motor-insurance/gcv/",
    "/customer/motor-insurance/gcv/products-list/:id",
    "/customer/motor-insurance/pcv/",
    "/customer/motor-insurance/pcv/products-list/:id",
    "/customer/motor-insurance/miscellaneous/",
    "/customer/motor-insurance/miscellaneous/products-list/:id",
    // Health
    "/customer/health-insurance/",
    "/customer/health-insurance/products-list/:id",
  ];

  const showAcubot = allowedPages.some((path) =>
    matchPath(path, location.pathname),
  );

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense
              fallback={
                <div className="flex justify-center items-center h-screen">
                  <h2 className=" font-bold bg-gradient-to-r from-green-500 to-teal-500 bg-clip-text text-transparent text-6xl">
                    Acuvisor
                  </h2>
                </div>
              }
            >
              {" "}
              <BApp />
            </Suspense>
          }
        />

        {/* Static Pages */}
        <Route
          path="/about-us"
          element={
            <Suspense
              fallback={
                <div className="flex justify-center items-center h-screen">
                  <h2 className=" font-bold bg-gradient-to-r from-green-500 to-teal-500 bg-clip-text text-transparent text-6xl">
                    Acuvisor
                  </h2>
                </div>
              }
            >
              {" "}
              <AboutUs />{" "}
            </Suspense>
          }
        />

        <Route
          path="/customer/service-page/"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <ServicePage />{" "}
            </Suspense>
          }
        />

        <Route
          path="/our-team"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <OurTeam />
            </Suspense>
          }
        />
        <Route
          path="/career"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <Career />
            </Suspense>
          }
        />
        <Route
          path="/contact-us"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <ContactUs />
            </Suspense>
          }
        />

        <Route
          path="/customer/pet-insurance"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <ProductSuppportContact pageCode={PageCodesHero.PetInsurance} />
            </Suspense>
          }
        />
        <Route
          path="/customer/life-insurance"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <QuickQuotePage />
            </Suspense>
          }
        />
        <Route
          path="/customer/travel-insurance"
          element={
            <Suspense
              fallback={
                <div className="flex justify-center items-center h-screen">
                  <h2 className=" font-bold bg-gradient-to-r from-green-500 to-teal-500 bg-clip-text text-transparent text-6xl">
                    Acuvisor
                  </h2>
                </div>
              }
            >
              <TravelQQPage />
            </Suspense>
          }
        />

        <Route
          path="/disclaimer"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <InfoDocPages pageCode={PageCodes.Disclaimer} />
            </Suspense>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <InfoDocPages pageCode={PageCodes.PrivacyPolicy} />
            </Suspense>
          }
        />
        <Route
          path="/grievance"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <InfoDocPages pageCode={PageCodes.Grievance} />
            </Suspense>
          }
        />
        <Route
          path="/terms-of-use"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {" "}
              <InfoDocPages pageCode={PageCodes.TermsOfUse} />
            </Suspense>
          }
        />

        <Route
          path="/signin"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <SignIn defaultOpen={true} />
            </Suspense>
          }
        />
        <Route
          path="/customer/health-insurance/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <HealthRoutes />
            </Suspense>
          }
        />
        {/* <Route path="customer/motor-insurance/*" element={<Suspense fallback={<div>Loading...</div>}><MotorRoutes /></Suspense>} /> */}
        <Route
          path="/customer/motor-insurance/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <MotorRoutes />
            </Suspense>
          }
        />
      </Routes>
      {showAcubot && <Acubot />}
    </>
  );
};

export default CustomerRoutes;
